import React, {
    useState,
    useCallback,
    useContext,
    useEffect,
    useMemo,
} from "react";
import _, { get } from "lodash";
import PropTypes from "prop-types"
import {  withViewModelService,ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

;

import { withRouter } from "react-router-dom";
import { useTranslator,IntlContext } from "@jutro/locale";
import { MetadataContent } from "@jutro/legacy/uiconfig";
import { ServiceRequestService } from "gw-capability-servicerequest";
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import {  ModalNextContext } from "@jutro/components";
import { LoaderExt } from 'gw-components-platform-react';
import moment from "moment";
import PayrollService from "cpmi-capability-payroll/services/PayrollService";
import useGoogleAnalytics from "account-management/src/hooks/useGoogleAnalytics";
import metadata from "./PayrollReviewGL.metadata.json5";
import messages from "./PayrollReviewGL.messages";
import styles from "./PayrollReviewGL.module.scss";
// import PayrollInvoiceTable from './PayrollInvoiceTable/PayrollInvoiceTable';
import { end } from "cheerio/lib/api/traversing";

function PayrollReviewGL(props) {
    
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const [state,setStateName]=useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const [viewStartPage, setviewStartPage] = useState(true);
    const [trackGAPageView]=useGoogleAnalytics();
    const [draftData,setDraftData]=useState({})
    const ModalNext = useContext(ModalNextContext);
    const intl = useContext(IntlContext);

    const { history } = props;
    const {onCallback,DraftDataFromReview} = props;
    const appValue=props?.location?.state?.appValue
    let  reviewData;
   
    let totalsArray =[];
    if(appValue==="CE")
    {
        reviewData = _.get(props, "location.state.data");    
    }
    else{
        reviewData = _.get(props, "data");
       
       
    }

    useEffect(() => {
        trackGAPageView("/payroll-reporting/reviewGL","Payroll Review")
    },[])
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const individualData=reviewData?.policyPremium!==undefined?reviewData?.policyPremium?.individualCosts:[]
    
    const handleSubmit = useCallback(() => {
        setLoadingState(true)
        ModalNext.showConfirm({
            title: messages.submitTitleGL,
            message: appValue==="PE"?messages.PEsubmitMessageGL:messages.submitMessageGL,
            status: "info",
            icon: "mi-error-outline",
            confirmButtonText: "Submit Report",
            cancelButtonText: "Edit Report",
            closeButton:"false"
        }).then(async (results) => {
            if (results === "confirm") {
                if (appValue === "PE") {
                    await PayrollService.PEsubmitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({pathname:props.location.peMainPayrollPath,state:"submitted",policyNumber:reviewData.policyNumber})
                } else {
                    await PayrollService.submitPayrollReport(
                        reviewData?.jobNumber,
                        authHeader
                    );
                    setLoadingState(false)
                    history.push({
                        pathname: `/payroll-reporting/list/success`,
                        state: {
                            appValue: "submitted",
                        },
                    });
                }
            } else if(appValue==='PE')
            {
                onCallback(true)
            }
            else{
                //history.go(-1);
                const pathValue = `/payroll-reporting/startpayrollGL`
                history.push({
                    pathname: pathValue,
                    state: {
                        jobNumber: reviewData?.jobNumber,payrollFlag:"Make Changes Payroll",page:"Start",appValue:"CE"
                    },
                })
               
            }
        }, _.noop);
    }, [ModalNext, appValue, authHeader, history, onCallback, reviewData?.jobNumber, reviewData?.policyNumber]);

    const handleMakeChanges = useCallback(async() => {
       
        if(appValue==='PE')
        {
            const res = await PayrollService.PEchangeReportStatusToDraft(reviewData?.jobNumber,authHeader)

            setDraftData(res)
            setviewStartPage(true);
            onCallback(true)
            DraftDataFromReview(res)
        }
        else{
            const pathValue = `/payroll-reporting/startpayrollGL`
            await PayrollService.changeReportStatusToDraft(reviewData?.jobNumber,authHeader)
            history.push({
                pathname: pathValue,
                state: {
                    jobNumber: reviewData?.jobNumber,payrollFlag:"Make Changes Payroll",page:"Start",appValue:"CE"
                },
            })
           // history.go(-1);
        }
          
    }, [DraftDataFromReview, appValue, authHeader, history, onCallback, reviewData?.jobNumber]);

    const getFormatAmt = (value) => {
        // value=value.toFixed(2)
        var val = Math.round(Number(value) * 100) / 100;

        var parts = val.toFixed(2).split(".");

        var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");

        return num
    }

    const getTotalAmount = useCallback(() => {
        let totalAuditedAmount = 0
        
        reviewData?.gl7SubLinePremiums?.map((itrator)=>{
            totalAuditedAmount +=itrator.auditedSubTotal
        })

        reviewData?.gl7ExposurePremiums?.map((expPre)=>{
            expPre?.gl7ExposureSublines?.map((expSub)=>{
                expSub.gl7ExposureLocations.map((itrator)=>{
                    totalAuditedAmount +=itrator.auditedSubTotal
                })                
            })
        })
        // eslint-disable-next-line array-callback-return
        reviewData?.gl7PolicyPremiums?.map((itrator)=>{
            totalAuditedAmount += itrator.totalAuditedAmount?.amount ?? 0
        })

        if(totalAuditedAmount!==undefined)
        {
            const amount = totalAuditedAmount.toFixed(
                2
            );

            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})

            return <span className={styles.textAlignment}>Total Premium: ${getFormatAmt(amount)}</span>;
        }
        
        return ' '
        
        
    }, [reviewData?.gl7PolicyPremiums, totalsArray]);

    const rederPrmiumAmountFormat = useCallback((amountValue) => {
        

        if(amountValue!==undefined)
        {
            const amount = amountValue.toFixed(
                2
            );

            totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})

            return `$${  getFormatAmt(amount)}`;
        }
        
        return ' '
        
        
    }, [totalsArray]);

    const renderSublines = useCallback((loopItem) => {
        
        return loopItem?.gl7Costs?.map((subLoopItem)=>{
        return <div className={styles.bodyContentClass}>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.locationNmae}</div>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.classCode}</div>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.sublineForCost}</div>
                             <div className={styles.bodyContentClassStyle}>{moment(subLoopItem.effectiveDate).format('MM/DD/YYYY')}</div>
                             <div className={styles.bodyContentClassStyle}>{moment(subLoopItem.expirationDate).format('MM/DD/YYYY')}</div>
                             <div className={styles.bodyContentClassStyle}>{getFormatAmt(subLoopItem.audited)}</div>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.rate}</div>
                             <div className={styles.bodyContentClassStyleAmount}>{ rederPrmiumAmountFormat(subLoopItem.auditedAmount?.amount ?? 0)}</div>
                         </div>
                         

         })

        
     },[])

     const renderSublinesCost = useCallback((loopItem) => {
        
        return loopItem?.gl7Costs?.map((subLoopItem)=>{
        return <div className={styles.bodySublineContentClass}>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.coverage}</div>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.classCode}</div>                             
                             <div className={styles.bodyContentClassStyle}>{moment(subLoopItem.effectiveDate).format('MM/DD/YYYY')}</div>
                             <div className={styles.bodyContentClassStyle}>{moment(subLoopItem.expirationDate).format('MM/DD/YYYY')}</div>
                             <div className={styles.bodyContentClassStyle}>{getFormatAmt(subLoopItem.audited)}</div>
                             <div className={styles.bodyContentClassStyle}>{subLoopItem.rate}</div>
                             <div className={styles.bodyContentClassStyleAmount}>{rederPrmiumAmountFormat(subLoopItem.auditedAmount?.amount ?? 0)}</div>
                         </div>
                         

         })

        
     },[])


     const sublineTotals = useCallback((loopItem) => {
     return <div style={{'padding-bottom': '70px'}}>
     <div className={styles.subLineTotal}>
            <div></div>
            <div></div>
            <div></div>
           <div>Subline Total</div>
           <div style={{textAlign:'end'}}>{rederPrmiumAmountFormat(loopItem.totalAuditedAmount?.amount ?? 0)}</div>
       </div>
       </div>
},[])

const glSublineTotals = useCallback((loopItem) => {
    return <div style={{'padding-bottom': '70px'}}>
    <div className={styles.subLineTotal}>
           <div></div>
           <div></div>
           <div></div>
          <div>Sub Total</div>
          <div style={{textAlign:'end'}}>${getFormatAmt(loopItem.auditedSubTotal)}</div>
      </div>
      </div>
},[])

const glExpTotals = useCallback((loopItem) => {
    return <div style={{'padding-bottom': '70px'}}>
    <div className={styles.subLineTotal}>
           <div></div>
           <div></div>
           <div></div>
          <div>State Sub Total</div>
          <div style={{textAlign:'end'}}>${getFormatAmt(loopItem.auditedSubTotal)}</div>
      </div>
      </div>
},[])
    const renderHeaderColumns = useCallback((loopItem) => {
    return <><div className={styles.jurictionNameClass}>{loopItem.jurisdicationName}</div>
    <div className={styles.mainHeaderClass}>
        <div className={styles.headerStyleClass}>Location</div>
        <div className={styles.headerStyleClass}>Code</div>
        <div className={styles.headerStyleClass}>Subline</div>
        <div className={styles.headerStyleClass}>Effective</div>
        <div className={styles.headerStyleClass}>Expiry</div>
        <div className={styles.headerStyleClass}>Basis</div>
        <div className={styles.headerStyleClass}>Rate</div>
        <div className={styles.headerStyleClassPremium}>Amount</div>
    </div><div>{renderSublines(loopItem)}</div><div>{sublineTotals(loopItem)}</div></>
    
                    },[renderSublines])

    
    const renderSubHeaderColumns = useCallback((loopItem) => {
        return(
            <>
        {(loopItem.gl7Costs.length > 0) ?
         <>        
        <div className={styles.subLineJurictionNameClass}>{loopItem.subLineName}</div>
        <div>{renderSublinesCost(loopItem)}</div><div>{glSublineTotals(loopItem)}</div></> : <></>
        }
        </>)
        
                        },[renderSublinesCost])

    const renderExpHeader2Columns = useCallback((loopItem) => {
        return loopItem.gl7Costs.length > 0  ? <>        
        <div className={styles.exp2JurictionNameClass}>{loopItem.locationName}</div>
        <div>{renderSublinesCost(loopItem)}</div><div>{glExpTotals(loopItem)}</div></> : <></>
        
        },[renderSublinesCost])

    const renderExpHeader1Columns = useCallback((loopItem) => {
        return loopItem.glExpSubVisible ?  <>        
        <div className={styles.exp1JurictionNameClass}>{loopItem.sublineName}</div>
        { loopItem?.gl7ExposureLocations?.map((loopItem) => {
                return renderExpHeader2Columns(loopItem) 
                })
            
        }        
        </>  : <></>       
        
        },[renderExpHeader2Columns])

    
    const renderExpHeaderColumns = useCallback((loopItem) => {
        return loopItem.glExpJurVisible ? <>        
        <div className={styles.subLineJurictionNameClass}>{loopItem.jurisdicationName}</div>
        { loopItem?.gl7ExposureSublines?.map((loopItem) => {
                return renderExpHeader1Columns(loopItem) 
                })
            
        }        
        </> : <></>
        
     },[renderExpHeader1Columns])  

    const generateTable = useCallback(() => {
        // Composite GL rolls all premium into the composite endorsement, leaving the Exposures
        // and policy-premium subline sections present but $0. Render each only when it carries
        // real audited premium (non-composite); glSubPremVisible is true for both, so it can't
        // discriminate here.
        let exposureAuditedTotal = 0;
        reviewData?.gl7ExposurePremiums?.forEach(expPre =>
            expPre?.gl7ExposureSublines?.forEach(expSub =>
                expSub?.gl7ExposureLocations?.forEach(loc => {
                    exposureAuditedTotal += loc.auditedSubTotal || 0;
                })
            )
        );
        let policyPremiumAuditedTotal = 0;
        reviewData?.gl7PolicyPremiums?.forEach(pol => {
            policyPremiumAuditedTotal += pol.totalAuditedAmount?.amount || 0;
        });

        return (
            <>
            {(reviewData.glSubPremVisible || reviewData.glExpPremVisible) ?
            <>
            <div>
            <div className={styles.mainSubLineHeaderClass}>
            <div className={styles.headerStyleClass}>Coverage</div>
            <div className={styles.headerStyleClass}>Code</div>
            <div className={styles.headerStyleClass}>Effective</div>
            <div className={styles.headerStyleClass}>Expiry</div>
            <div className={styles.headerStyleClass}>Basis</div>
            <div className={styles.headerStyleClass}>Rate</div>
            <div className={styles.headerStyleClassPremium}>Amount</div>
        </div>
        <div className={styles.jurictionNameClass}>General Liability</div>
            { reviewData?.gl7SubLinePremiums?.map((loopItem) => {
                return renderSubHeaderColumns(loopItem)
                })

        }
        {reviewData?.gl7ExposurePremiums?.length > 0 && exposureAuditedTotal > 0 &&
        <>
        <div className={styles.jurictionNameClass}>Exposures</div>
        { reviewData?.gl7ExposurePremiums?.map((loopItem) => {
                return renderExpHeaderColumns(loopItem)
                })

        }
        </>
        }
            </div>
            </> : <></>}
            {reviewData?.gl7PolicyPremiums?.length > 0 && policyPremiumAuditedTotal > 0 &&
            <div>
                { reviewData?.gl7PolicyPremiums?.map((loopItem) => {
                    return renderHeaderColumns(loopItem)
                    })
                }
            </div>
            }
            </>
        )


    }, [renderSublines, reviewData?.gl7PolicyPremVisible, reviewData?.gl7PolicyPremiums, reviewData?.gl7ExposurePremiums, reviewData?.glSubPremVisible])

    const getTotalAmountTop = useCallback(() => {

        let totalAuditedAmount = 0

        reviewData?.gl7SubLinePremiums?.map((itrator)=>{
            totalAuditedAmount +=itrator.auditedSubTotal
        })

        reviewData?.gl7ExposurePremiums?.map((expPre)=>{
            expPre?.gl7ExposureSublines?.map((expSub)=>{
                expSub.gl7ExposureLocations.map((itrator)=>{
                    totalAuditedAmount +=itrator.auditedSubTotal
                })                
            })
        })

        // eslint-disable-next-line array-callback-return
        reviewData?.gl7PolicyPremiums?.map((itrator)=>{
            totalAuditedAmount += itrator.totalAuditedAmount?.amount ?? 0
        })

        const amount = totalAuditedAmount.toFixed(
            2
        );

        totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})

        return `$${ getFormatAmt(amount)}`
        
        // if(reviewData?.gl7PolicyPremiums[0]?.totalAuditedAmount!==undefined)
        // {
        //     const amount = reviewData?.gl7PolicyPremiums[0]?.totalAuditedAmount?.amount?.toFixed(
        //         2
        //     );
        //     totalsArray.push({description:"Total Policy Premium",amount:`$${  amount}`})
        //     return <span className={styles.textAlignmentTop}>${amount}</span>;
        // }
        
        return totalAuditedAmount
        
        
    }, [reviewData]);


    const getPolicyPeriod = useCallback(() => {

        
        const startperiod = moment(reviewData?.reportPeriodStart).format(
            "MM/DD/YYYY"
        );
        const endDate = moment(reviewData?.reportPeriodEnd).format("MM/DD/YYYY");
        if(reviewData?.hasOwnProperty('paymentFrequency')){
            const paymentFrequency= reviewData?.paymentFrequency;
            return `Payroll Period : ${startperiod} - ${endDate} - (${paymentFrequency})`;
        }
        return `Payroll Period : ${startperiod} - ${endDate} `;
       
    }, [reviewData]);

    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // const renderDescription=useCallback((item)=>{
    //     return item.description
    // })
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // const RenderTotalAmount=useCallback((item)=>{
    //     return item.amount
    // })

    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // const renderEmpty=useCallback((item)=>{
    //     return ''
    // })
    

    

    const generateOverrides = useMemo(() => {
       
        let overrides={}
        if(appValue==="CE")
        {
            overrides = individualData?.map((item, index) => {
                return {
                    [`invoiceTable${index}`]: {
                        data: individualData[index],
                    },
                  
                    
                };
            });
        }
        else{
            overrides = individualData?.map((item, index) => {
                return {
                    [`invoiceTable${index}`]: {
                        data: individualData[index],
                    },
                  
                    
                };
            });  
        }

        return Object.assign({}, ...overrides);
    }, [appValue, individualData]);

    
    

    

    
    

    const override = {
        
        ...generateOverrides,
        
        policyNumberId: {

            content: `Policy : ${reviewData?.policyNumber}`,
        },
        policyperiodId: {
            content: getPolicyPeriod(),
        },
        totalcostdataId: {
            // value: `$${reviewData.policyPremium.totalPremiumOfReport.amount.toFixed(2)}`
            content: getTotalAmount(),
        },
        totalcostdataIdTop:{
            content: getTotalAmountTop(),
        },
        // reviewDataTable:{
        //     data:reviewData?.gl7PolicyPremiums[0]?.gl7Costs
        // },
        tableDiv:{
            content:generateTable()
        }
        // payrollDetails:{
        //     data:individualData || []
        // },
        // totalDescId:{
        //     value:"Description"
        // },
        // totalAmountId:{
        //     value: getTotalAmount(),
        // }
        // payrollTotalTable:{
        //     visible:false,
        //     data:totalsArray
        // }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        
        resolveCallbackMap: {
            // renderDescription:renderDescription,
            // RenderTotalAmount:RenderTotalAmount,
            handleMakeChanges: handleMakeChanges,
            handleSubmit: handleSubmit,
            // renderEmpty:renderEmpty,


            // renderCellData:getCell,
            // renderAuditedAmount,
            // renderEstimatedAmount,
            // getFormattedDate
        },
        resolveComponentMap:{
            // PayrollInvoiceTable:PayrollInvoiceTable
        }
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }


    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={override}
            {...resolvers}
        />
    );
    
}
PayrollReviewGL.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({}),
        }),
    }).isRequired,
};

export default withRouter(withViewModelService(PayrollReviewGL));
